
import { useParams } from 'react-router-dom';
import { ThemeFormState } from '../../../context/theme/ThemeFormState';
import { Form } from './form';

export const ThemeFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Theme":"Crear Theme";
  
  return (
    <ThemeFormState>
        <br />
        <Form title={title} />
    </ThemeFormState>
  );
};
